import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer header fallback when localStorage token is present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// SEC-002: auto-refresh access token on 401 (once per request), then retry.
let _refreshInFlight = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = (original.url || "").toString();
    const isAuthEndpoint = /\/auth\/(login|register|refresh|logout)$/.test(url);
    if (status !== 401 || original._retry || isAuthEndpoint) {
      return Promise.reject(error);
    }
    original._retry = true;
    try {
      if (!_refreshInFlight) {
        _refreshInFlight = axios
          .post(`${API}/auth/refresh`, {}, { withCredentials: true })
          .finally(() => { _refreshInFlight = null; });
      }
      const { data } = await _refreshInFlight;
      if (data && data.access_token) {
        localStorage.setItem("cs_access_token", data.access_token);
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${data.access_token}`;
      }
      return api.request(original);
    } catch (refreshErr) {
      localStorage.removeItem("cs_access_token");
      return Promise.reject(error);
    }
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
